export default function scriptFooter() {
	document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.local-tab');
    const contents = document.querySelectorAll('.tab-content');
		const mailCopyDivs = document.querySelectorAll('.mail-copy');
    
    tabs[0].classList.add('active');
    document.getElementById(tabs[0].dataset.id).classList.add('active');

    function switchTab(clickedTab) {
        tabs.forEach(tab => tab.classList.remove('active'));
        contents.forEach(content => content.classList.remove('active'));
        
        const targetId = clickedTab.dataset.id;
        clickedTab.classList.add('active');
        document.getElementById(targetId).classList.add('active');
    }

    tabs.forEach(tab => {
        tab.addEventListener('click', function() {
            if (!this.classList.contains('active')) {
                switchTab(this);
            }
        });
    });

		mailCopyDivs.forEach(mailCopyDiv => {
			const emailSpan = mailCopyDiv.querySelector('span');
		
			if (emailSpan && !emailSpan.dataset.originalText) {
					emailSpan.dataset.originalText = emailSpan.textContent.trim();
			}

			mailCopyDiv.addEventListener('click', async function() {
					if (emailSpan) {
							try {
									await navigator.clipboard.writeText(emailSpan.dataset.originalText);
						
									emailSpan.textContent = 'Copiado para área de transferência';
									this.classList.add('active-copy');
									
									setTimeout(() => {
											this.classList.remove('active-copy');
											emailSpan.textContent = emailSpan.dataset.originalText;
									}, 5000);
									
							} catch (err) {
									console.error('Falha ao copiar: ', err);
							}
					}
			});
		});
		
	});
}